import { reducer as about } from './modules/about';
import { reducer as app } from './modules/app';
import { reducer as catalog } from './modules/catalog';
import { reducer as home } from './modules/home';
import { reducer as alerts } from './modules/alerts';
import { reducer as layout } from './modules/layout';
import { reducer as staff } from './modules/staff';
import { reducer as teams } from './modules/teams';

export default {
  about,
  alerts,
  app,
  catalog,
  home,
  layout,
  staff,
  teams,
};
